import { RootState } from 'app/store';
import { mapUwtTypeToOptions } from 'modules/utils/mappers/leasingCalculatorCodesMapper';

export const selectDocumentation = (state: RootState) => state.documentation;

export const selectUploadError = (state: RootState) =>
  state.documentation.uploadError;

export const selectUploadSuccess = (state: RootState) =>
  state.documentation.uploadSuccessful;

export const selectUploadLoading = (state: RootState) =>
  state.documentation.uploadLoading;

export const selectDocumentTypeCodesOptions = (state: RootState) =>
  mapUwtTypeToOptions(state.documentation.documentTypes.data);
